<template>
  <nav
    v-if="!$route.meta.suppressMainNavigation && !isRollover"
    class="navbar"
    role="navigation"
    aria-label="main navigation"
  >
    <div class="navbar-menu">
      <div class="navbar-start">
        <span
          class="navbar-item"
          @click="receiveAQuoteClick"
          :class="{
            'padding-left-adjustment': !isLoggedIn
          }"
        >
          Receive a Quote
        </span>
        <router-link
          class="navbar-item"
          to="/faq"
          @click.native="toggleNav(true)"
          >FAQ</router-link
        >
        <div class="navbar-item">
          <span @click="exploreBenefitsClick()">Explore Benefits</span>
        </div>
        <template>
          <router-link
            class="navbar-item padding-left-adjustment"
            to="/account/claims"
            @click.native="toggleNav(true)"
            >Claims</router-link
          >
        </template>
        <router-link
          class="navbar-item"
          to="/contact-us"
          @click.native="toggleNav(true)"
          >Contact Us</router-link
        >
      </div>
    </div>
  </nav>
</template>

<script>
import AnchorRouterLink from 'vue-anchor-router-link';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'MainNavigation',
  data: () => ({
    showBenefitsSubmenu: false
  }),
  components: {
    AnchorRouterLink
  },
  props: {},
  model: {
    event: 'toggleNav'
  },
  methods: {
    ...mapActions(['toggleNav', 'logOut']),
    invokeLogOut: function() {
      this.logOut().then(() => {
        this.$router.push('/');
      });
    },
    exploreBenefitsClick() {
      console.log(document.getElementById('exploring-benefits'));
      this.showBenefitsSubmenu = false;
      if (this.$route.path !== '/') {
        this.$router.push('/');
      }
      setTimeout(() => {
        const container = document.getElementById('exploring-benefits');
        container.scrollIntoView();
        // container.scrollIntoView({ behavior: 'smooth' });
        // document.getElementById('exploring-benefits').scrollTo(0,0)
      }, 150);
    },
    receiveAQuoteClick() {
      if (this.$route.path !== '/receive-a-quote') {
        this.$router.push('/receive-a-quote');
        setTimeout(() => {
          let container = document.getElementById('quote-container');
          container.scrollIntoView({ behavior: 'smooth' });
        }, 200);
      }
    }
  },
  computed: {
    ...mapGetters(['activeNav', 'isLoggedIn', 'isRollover'])
  }
};
</script>

<style lang="scss" scoped>
.navbar {
  padding: 0 2%;
}
.navbar-menu {
  @media only screen and (min-width: 63.9375em) {
    flex-grow: 0;
  }
}
.navbar-item {
  color: #000;
  padding-left: 1rem;
  padding-right: 1rem;

  @media only screen and (min-width: 1200px) {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  &:hover {
    background-color: inherit;
  }
}
.padding-left-adjustment {
  padding-left: 0 !important;
}
span.navbar-item,
div.navbar-item {
  cursor: pointer;
  padding-left: 1rem;
  padding-right: 1rem;
  @media only screen and (min-width: 1200px) {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  &:hover {
    background-color: inherit;
    color: #d5001c;
  }
}
.benefits-submenu {
  display: inline-block;
  background-color: $white;
  border: solid 1px #e3e4e4;
  position: absolute;
  top: 100%;
  left: 0;
  width: 200px;
}
div.submenu-item {
  margin-top: -1px;
  padding-top: 0;
  padding-bottom: 0;
  padding-left: 1rem;
  padding-right: 1rem;
  width: 100%;

  &:hover {
    color: #d5001c;
  }
  span {
    display: block;
    width: 100%;
    font-size: 16px;
    line-height: 24px;
    padding: 0.5rem 0.5rem;
    border-top: 1px solid #e3e4e4;
  }
}
div.submenu-first-item {
  border-top: 1px solid #e3e4e4;
  span {
    border-top: none;
  }

  &:after {
    position: absolute;
    top: -9px;
    left: 43px;
    width: 0;
    height: 0;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #fff;
    border-left: 10px solid transparent;
    content: '';
  }
  &:before {
    position: absolute;
    top: -10px;
    left: 43px;
    width: 0;
    height: 0;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #ccc;
    border-left: 10px solid transparent;
    content: '';
  }
}
</style>
